import React, { Fragment } from 'react'
import { Link } from 'components/link'

export default function CookiesPolicyEN(props) {
  return (
    <Fragment>
      <span className="about__title">Cookie Policy Darpo Vision FZ LLC</span>
      <div className="about">
        <div className="about-block">
          <div className="about-block-full">
            <div className="about-block-text about-block-text--wide">
              <h2>1. Consent</h2>
              <p>
                This policy is provided by Darpo Vision FZ LLC (DBA Viory)
                (“Viory”, “we”, “us”, or “our”) in connection with the use of
                our Website <Link to="/">http://viory.video</Link> and its
                subdomains (together “Websites”).
              </p>

              <p>
                By using our Websites, You consent to the use of cookies in
                accordance with this policy. You may withdraw your consent at
                any time by following the instructions below.
              </p>
              <br />
              <h2>
                2. Pseudonymous Usage Profiles for Advertising and Market
                Research Purposes (Web Tracking and Analysis)
              </h2>
              <p>
                Viory uses web tracking systems for advertising, market research
                and to make your use of our Websites as pleasant as possible. In
                this case, data on the use of our Websites is stored in
                pseudonymous user profiles (your IP address is anonymized). This
                enables us to further develop our website and tailor the content
                even better to your needs. You can object to the creation of
                pseudonymous user profiles. For this purpose, you can prevent
                the setting of cookies in your browser (see section 5).
              </p>
              <br />
              <p>
                You can also install a plugin in your browser to protect your
                privacy, which allows You to prevent tracking – e. g. AdBlock,
                Ghostery or NoScript (please refer to the privacy policy of the
                respective plugin provider). In addition, some tracking
                providers are members of industry associations (see below in
                detail), whose websites allow You to centrally object to
                usage-based online advertising by their respective members.
              </p>
              <p>
                Below you will find the websites of these associations for a
                convenient cross-provider opt-out:
              </p>
              <ul style={{ paddingLeft: '2rem' }}>
                <li>
                  "European Interactive Digital Advertising Alliance" (EDAA):{' '}
                  <a href="http://www.youronlinechoices.com/de/praferenzmanagement/">
                    http://www.youronlinechoices.com/de/praferenzmanagement/
                  </a>
                </li>
                <li>
                  "Digital Advertising Alliance" (DAA):{' '}
                  <a href="http://www.aboutads.info/choices/">
                    http://www.aboutads.info/choices/
                  </a>
                </li>
                <li>
                  "Network Advertising Initiative" (NAI):{' '}
                  <a href="http://www.networkadvertising.org/choices/">
                    http://www.networkadvertising.org/choices/
                  </a>
                </li>
              </ul>
              <br />
              <h2>3. Disabling cookies</h2>
              <p>
                If You do not agree to the use of these cookies please disable
                them by following the instructions for your browser set out here
                or use the automated disabling tool where available. However,
                please keep in mind that disabling cookies may affect the
                functionality and feature of our Websites.
              </p>
              <p>
                Where the organisation setting the cookie provides an automated
                disabling tool in respect of its cookie(s) we list the name of
                that organisation, the category of cookies it sets together with
                a link to its automated disabling tool. In all other cases, we
                list the names of the cookies themselves and their source so
                that You can easily identify and disable them, if You want,
                through your browser controls.
              </p>
              <br />
              <h2>4. What are cookies?</h2>
              <p>
                A cookie is a small text file that a website saves on your
                computer or mobile device when You visit the site. It enables
                the website to remember your actions and preferences (such as
                login, language, font size and other display preferences) over a
                period of time, so you don’t have to keep re-entering them
                whenever You come back to the site or browse from one page to
                another. Furthermore, they help us to understand website usage
                of visitors and to improve or customize our products, content,
                offerings, services or advertisements.
              </p>
              <p>
                Cookies are useful because they allow a website to recognise a
                user’s device. Cookies allow You to navigate between pages
                efficiently, remember preferences and generally improve the user
                experience. They can also be used to tailor advertising to your
                interests through tracking your browsing across websites.
              </p>
              <p>
                Session cookies are deleted automatically when You close your
                browser and persistent cookies remain on your device after the
                browser is closed (for example to remember your user preferences
                when you return to the site).
              </p>
              <br />
              <h2>5. What types of cookies does Viory use?</h2>
              <p>
                We describe the categories of cookies Viory and its contractors
                use below.
              </p>
              <p>
                After your initial visit to our Websites we may change the
                cookies we use. This policy will be updated and will always give
                You the means to know who is setting cookies, for what purpose
                they are used and the means to disable them so You should check
                it from time to time.
                <br />
                <br />
              </p>
              <div style={{ paddingLeft: '2rem' }}>
                <h2>5.1. Strictly necessary cookies</h2>
                <p>
                  These cookies are essential in order to enable You to move
                  around the Website and use its features. Without these
                  cookies, services You have asked for (such as navigating
                  between pages) cannot be provided.
                </p>
                <p>
                  Our Websites currently use the following strictly necessary
                  cookies:
                </p>
                <p>
                  Cookie Name: CloudFront-Signature
                  <br />
                  Data Stored: A user’s signature to prevent unauthorized file
                  downloads
                  <br />
                  Purpose: Amazon Cloudfront to identify user eligible for
                  download
                  <br />
                  Expires: Session - The moment you close your browser.
                  <br />
                  Source: viory.video
                  <br />
                </p>
                <p>
                  Cookie Name: CloudFront-Policy
                  <br />
                  Data Stored: A CloudFront download policy to prevent
                  unauthorized file downloads
                  <br />
                  Purpose: Amazon Cloudfront to identify resource eligible for
                  download
                  <br />
                  Expires: Session - The moment you close your browser.
                  <br />
                  Source: viory.video
                  <br />
                </p>
                <p>
                  Cookie Name: CloudFront-Key-Pair-Id
                  <br />
                  Data Stored: A CloudFront key pair <br />
                  Purpose: Amazon Cloudfront to identify resource eligible for
                  download
                  <br />
                  Expires: Session - The moment you close your browser.
                  <br />
                  Source: viory.video
                  <br />
                </p>
                <br />
                <h2>5.2. Performance cookies</h2>
                <p>
                  We make use of analytic cookies to analyse how our visitors
                  use our Websites and to monitor Websites performance. This
                  allows us to provide a high-quality experience by customising
                  our offering and quickly identifying and fixing any issues
                  that arise. For example, we might use performance cookies to
                  keep track of which pages are most popular, which method of
                  linking between pages is most effective, and to determine why
                  some pages are receiving error messages. We might also use
                  these cookies to highlight articles or Website services that
                  we think will be of interest to You based on your usage of the
                  Websites. The information collected by these cookies is not
                  associated with your personal information by us or by our
                  contractors.
                </p>
                <p>
                  Our Websites use Amplitude Services provided by Amplitude,
                  Inc. with its offices at 201 3rd Street, Suite 200, San
                  Francisco, CA 94103 ("Amplitude»).
                </p>
                <p>
                  Our Websites use Google Analytics, a web analytics service by
                  Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA
                  94043, USA (“Google”). Google Analytics uses cookies in order
                  to analyse your use of our Websites. The information about
                  your use of our Websites collected using cookies is usually
                  transferred to and stored on servers of Google Inc. in the US.
                  On behalf of the website provider Google will use this
                  information to analyse your use of the website, compiling
                  reports on website activity for website operators and
                  providing other services relating to website activity and
                  internet usage to the website provider. Google will not
                  combine your IP address with any other data held by Google.
                </p>
                <p>
                  You may refuse to have cookies stored on your device by
                  appropriately configuring your browser or by using a privacy
                  plugin. Furthermore, You can prevent Google’s collection and
                  use of data (cookies and IP address) by downloading and
                  installing the browser plug-in available here:{' '}
                  <a href="https://tools.google.com/dlpage/gaoptout?hl=en-GB">
                    https://tools.google.com/dlpage/gaoptout?hl=en-GB
                  </a>
                  . Further Information: Click the following link for Google’s
                  privacy policy in respect of Google Analytics{' '}
                  <a href="https://support.google.com/analytics/answer/4597324">
                    https://support.google.com/analytics/answer/4597324
                  </a>
                  .
                </p>
                <br />
                <p>
                  Our Websites currently use the following performance cookies:
                </p>
                <p>
                  Cookie Name: Anything starts with "AMP_"
                  <br />
                  Data Stored:
                  <br />
                  — deviceId: A randomly generated string
                  <br />
                  — userId: Upon user log-in, if the your instrumentation sends
                  this value to Amplitude, it's stored in the cookie. Amplitude
                  recommends you set this to uniquely identify users. Amplitude
                  encodes this value as Base64 before storing it.
                  <br />
                  — optOut: A flag to opt this device out of amplitude tracking.
                  If this flag is set, no additional information will be stored
                  for the user.
                  <br />
                  — sessionId: A randomly generated string for each session
                  <br />
                  — lastEventTime: Time of the last event, used to determine
                  when to expire and create a new session Id
                  <br />
                  — eventId: An incrementing sequence of identifiers used to
                  distinguish events
                  <br />
                  — identifyId: An incrementing sequence of identifiers used to
                  distinguish identify calls
                  <br />
                  — sequenceNumber: A sequence number used to order events and
                  identifies and properly sequence them
                  <br />
                  Purpose: The Amplitude coockies is used to keep track of
                  user’s behavior on the site throughout every session
                  <br />
                  Expires: 1 year
                  <br />
                </p>

                <p>
                  Cookie Name: _ga
                  <br />
                  Data Stored: A random unique number or string of letters and
                  numbers to identify your browser, the times and dates that You
                  interacted with the site recently and the marketing materials
                  or referring pages that led You to the site.
                  <br />
                  Purpose: Registers a unique ID that is used to generate
                  statistical data on how the visitor uses the website.
                  <br />
                  Source: Google Analytics
                  <br />
                  Expires: 2 years after your last visit to the website. The
                  moment you close your browser.
                  <br />
                </p>

                <p>
                  Cookie Name: __stripe_sid
                  <br />
                  Data Stored: Stripe session id <br />
                  Purpose: Stripe session id to identify users
                  <br />
                  Expires: Session - The moment you close your browser.
                  <br />
                </p>
                <p>
                  Cookie Name: __stripe_mid
                  <br />
                  Data Stored: Stripe analytics id <br />
                  Purpose: Stripe analytics id to measure web traffic
                  <br />
                  Expires: Session – 1 year
                  <br />
                </p>
                <h2>5.3. Website functionality cookies</h2>
                <p>
                  We make use of cookies to provide You with certain
                  functionality. For example, to remember choices You make (such
                  as your user name, language or the region you are in) and to
                  provide enhanced, more personal features. These cookies are
                  not used to track your browsing on other sites.
                </p>
                <p>
                  Our Websites currently use the following functional cookies:
                </p>
                <p>
                  Cookie Name: cookiesAccepted
                  <br />
                  Data Stored: true or false
                  <br />
                  Purpose: To remember if you have opted-out of Performance
                  Cookies
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 2 years <br />
                </p>

                <p>
                  Cookie Name: uae_regulated_content
                  <br />
                  Data Stored: “true” or “false”
                  <br />
                  Purpose: To remember your consent to access and view content
                  which may be explicit
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 2 years
                </p>
                <p>
                  Cookie Name: guid_token
                  <br />
                  Data Stored: 128-bit text string
                  <br />
                  Purpose: To add another layer of security. <br />
                  Source: viory.video
                  <br />
                  Expires: 1 year
                </p>

                <p>
                  Cookie Name:&nbsp;language_code
                  <br />
                  Data Stored: language code
                  <br />
                  Purpose: To remember user selected website language
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 1 year <br />
                </p>
                <p>
                  Cookie Name:&nbsp;cardRejected
                  <br />
                  Data Stored: number
                  <br />
                  Purpose: To keep track of how many times a user's payment card
                  has been declined
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 1 year <br />
                </p>
                <p>
                  Cookie Name:&nbsp;isUserWarned
                  <br />
                  Data Stored: "true" or "false"
                  <br />
                  Purpose: To check if the user has already seen the warning
                  about an unsuccessful payment
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 1 year <br />
                </p>
                <p>
                  Cookie Name:&nbsp;first_live_interaction
                  <br />
                  Data Stored: "true" or "false"
                  <br />
                  Purpose: To check if the user's first time interacting with
                  this feature 'Follow Live Event'
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 10 years <br />
                </p>
                <p>
                  Cookie Name:&nbsp;default_video_format
                  <br />
                  Data Stored: available video format
                  <br />
                  Purpose: To remember what video format you've downloaded the
                  last time and select same one on your next download
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 10 years
                  <br />
                </p>
                <p>
                  Cookie Name: _livechat
                  <br />
                  Data Stored: LiveChat settings
                  <br />
                  Purpose: Used by LiveChat – remembers the info of the visitor
                  entering our website
                  <br />
                  Expires: Session – 3 years
                  <br />
                </p>
                <p>
                  Cookie Name:&nbsp;newsletter_subscription
                  <br />
                  Data Stored: "true" or "false"
                  <br />
                  Purpose: checks if the user has interacted with the newsletter
                  subscription modal
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 90 days
                  <br />
                </p>
                <p>
                  Cookie Name:&nbsp;live_notify_follow
                  <br />
                  Data Stored: "cancel" or "approve"
                  <br />
                  Purpose: serves as a means to remember the user's decision
                  regarding the popup about live event notification
                  <br />
                  Source: viory.video
                  <br />
                  Expires: 45 days
                  <br />
                </p>
                <p>
                  Cookie Name:&nbsp;list_view_type
                  <br />
                  Data Stored: "list" or "grid"
                  <br />
                  Purpose: To remember how you prefer to view content lists
                  <br />
                  Source: viory.video
                  <br />
                  Expires: session.
                  <br />
                </p>
                <p>
                  Cookie Name:&nbsp;timezone
                  <br />
                  Data Stored: timezone name
                  <br />
                  Purpose: To remember what timezone You prefer
                  <br />
                  Source: viory.video
                  <br />
                  Expires: session.
                  <br />
                </p>
                <p>
                  Cookie Name: livechat_lastvisit <br />
                  Data Stored: LiveChat settings
                  <br />
                  Purpose: Stores when the visitor last used LiveChat.
                  <br />
                  Expires: Session – 3 years
                  <br />
                </p>
                <p>
                  Google &amp; YouTube: if You are logged into your Google
                  account while visiting our Websites, Google may be able to
                  track your use of certain websites (such as ours) which use
                  Google plug-ins, specifically, embedded YouTube videos. You
                  will have agreed to this arrangement as part of signing up for
                  a Google account, and Google will already have placed cookies
                  on your device for this purpose.
                  <br />
                  Most Google users will have a preferences cookie called ‘NID’
                  in their browsers. A browser sends this cookie with requests
                  to Google’s sites.
                </p>
                <p>
                  Cookie Name: NID
                  <br />
                  Data Stored: The NID cookie contains a unique ID Google.
                  <br />
                  Purpose: Google uses this ID to remember your preferences and
                  other information, such as your preferred language (e.g.
                  English), how many search results You wish to have shown per
                  page (e.g. 10 or 20), and whether or not You wish to have
                  Google’s SafeSearch filter turned on. In this case, NID will
                  be loaded if You play an embedded YouTube video from this
                  website
                  <br />
                  Source: google.com
                  <br />
                  Expires: 2 years
                  <br />
                </p>
                <p>
                  Further Information: Google's privacy policy on the
                  information which it obtains from these cookies can be found{' '}
                  <a href="http://www.google.com/intl/en/privacypolicy.html">
                    here
                  </a>
                  .
                </p>
                <h2>5.4. Marketing cookies</h2>
                <p>
                  These cookies track your online activity to help advertisers
                  deliver more relevant advertising or to limit how many times
                  You see an ad. These cookies can share that information with
                  other organizations or advertisers.
                </p>
                <p>
                  Our Websites use Facebook Pixel, a web analytics service by
                  Facebook Inc., 1601 S California Ave, Palo Alto, California
                  94304, USA. It enables us to measure, optimize and build
                  audiences for advertising campaigns served on Facebook.
                </p>
                <p>
                  You may refuse to have cookies stored on your device by
                  appropriately configuring your browser or by using a privacy
                  plugin. Furthermore, to opt-out please see:{' '}
                  <a href="https://www.facebook.com/ads/preferences">
                    https://www.facebook.com/ads/preferences
                  </a>
                  .
                  <br />
                  Further Information: Click the following link for Facebook's
                  Cookie Policy for details about the cookies used and the data
                  received{' '}
                  <a href="https://www.facebook.com/policies/cookies/">
                    https://www.facebook.com/policies/cookies/
                  </a>
                  .
                </p>
                <br />
                <p>
                  Cookie Name: _fbp
                  <br />
                  Data Stored: A random unique number or string of letters and
                  numbers to identify your browser.
                  <br />
                  Purpose: Used by Facebook to deliver a series of advertisement
                  products such as real time bidding from third party
                  advertisers.
                  <br />
                  Source: Facebook
                  <br />
                  Expires: 3 months.
                  <br />
                </p>
              </div>
              <h2>6. Use of IP addresses</h2>
              <p>
                We may also use your IP address to help diagnose problems with
                our server, to administer our Websites and to improve the
                service we offer to You. An IP address is a numeric code that
                identifies your computer on the internet. Your IP address might
                also be used to gather broad demographic information. We may
                perform IP lookups to determine which domain You are coming from
                (e.g.: google.com) to more accurately gauge our users’
                demographics.
              </p>
              <p>
                We may perform IP lookups to determine which domain you are
                coming from (e.g.: google.com) to more accurately gauge our
                users’ demographics.
                <br />
                Information from these types of cookies and technologies or
                about website usage is not combined with information about You
                from any other source.
              </p>
              <p>
                None of the cookies that we use will personally identify You.
              </p>
              <h2>7. Third party websites</h2>
              <p>
                Please note that this Cookie Policy does not apply to, and we
                are not responsible for, the privacy practices of third party
                websites which may be linked to our Websites.
              </p>
              <h2>8. Contact</h2>
              <p>
                If You have any questions, concerns, or complaints regarding
                this Policy or the use of cookies, please contact us:{' '}
                <a href="mailto:privacypolicy@viory.video">
                  privacypolicy@viory.video
                </a>
              </p>
              <h2>9. Changes to this policy</h2>
              <p>
                We may update this Policy and we would encourage You to review
                the Policy from time to time to stay informed of how we are
                using cookies.
              </p>
              <p>
                This Policy forms part of (and should be read in conjunction
                with) our Privacy Policy located{' '}
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  className="text-button text-button--big"
                >
                  here
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
